var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as PropTypes from 'prop-types';
import * as React from 'react';
import * as _ from 'lodash';
import { UIComponent, childrenExist, customPropTypes, commonPropTypes, } from '../../lib';
import Button from './Button';
/**
 * A button group presents multiple related actions.
 */
var ButtonGroup = /** @class */ (function (_super) {
    __extends(ButtonGroup, _super);
    function ButtonGroup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getStyleForButtonIndex = function (styles, isFirst, isLast) {
            var resultStyles = {};
            if (isFirst) {
                resultStyles = styles.firstButton;
            }
            if (isLast) {
                resultStyles = __assign({}, resultStyles, styles.lastButton);
            }
            if (!isFirst && !isLast) {
                resultStyles = styles.middleButton;
            }
            return resultStyles;
        };
        return _this;
    }
    ButtonGroup.prototype.renderComponent = function (_a) {
        var _this = this;
        var ElementType = _a.ElementType, classes = _a.classes, accessibility = _a.accessibility, styles = _a.styles, rest = _a.rest;
        var _b = this.props, children = _b.children, content = _b.content, buttons = _b.buttons, circular = _b.circular;
        if (_.isNil(buttons)) {
            return (React.createElement(ElementType, __assign({}, accessibility.attributes.root, rest, { className: classes.root }), childrenExist(children) ? children : content));
        }
        return (React.createElement(ElementType, __assign({}, rest, { className: classes.root }), _.map(buttons, function (button, idx) {
            return Button.create(button, {
                defaultProps: {
                    circular: circular,
                    styles: _this.getStyleForButtonIndex(styles, idx === 0, idx === buttons.length - 1),
                },
            });
        })));
    };
    ButtonGroup.displayName = 'ButtonGroup';
    ButtonGroup.className = 'ui-buttons';
    ButtonGroup.propTypes = __assign({}, commonPropTypes.createCommon(), { accessibility: PropTypes.oneOfType([PropTypes.object, PropTypes.func]), buttons: customPropTypes.collectionShorthand, circular: PropTypes.bool });
    ButtonGroup.defaultProps = {
        as: 'div',
    };
    return ButtonGroup;
}(UIComponent));
export default ButtonGroup;
